"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Smooth scrolling for anchor links
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.smoothScrolling = {
    bindSmoothScrolling: function () {
        // Select all links with hashes
        $('.onepager-navigation a[href*="#"]')
            // Remove links that don't actually link to anything
            .not('[href$="#"]')
            .not('[href$="#0"]')
            .on('click', function (event) {
            // On-page links
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
                location.hostname === this.hostname) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    // Wait for a while to get correct offset
                    setTimeout(function () {
                        $('html, body').animate({
                            scrollTop: (target.offset().top - _main_1.txGs1Base.smoothScrolling.getOffset())
                        }, 500, function () {
                            // Callback after animation
                            // Must change focus!
                            var $target = $(target);
                            $target.focus();
                            if ($target.not(":focus")) {
                                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            }
                        });
                    }, 200);
                }
            }
        });
    },
    getOffset: function () {
        var $onepagerNavigation = $('.onepager-navigation');
        var $offset = 0;
        // If the onepager navigation is available use it's height as offset
        // so the content is not hidden under the navigation
        // Use innerHeight to get correct height for handheld!
        if ($onepagerNavigation.length > 0) {
            $offset = $onepagerNavigation.innerHeight() + 25;
        }
        return $offset;
    },
    initialize: function () {
        'use strict';
        _main_1.txGs1Base.smoothScrolling.bindSmoothScrolling();
    }
};
exports.default = {};
